import React, { Component } from 'react'; //different
//import './style.css';
import instance from "./axios-instance";
import SweetAlert from 'react-bootstrap-sweetalert';
import jwt_decode from "jwt-decode";
import NavMenu from './navmenu';
import Systems from "./SystemFunction";
import Banner from './banner';
import Swal from 'sweetalert2'
import md5 from 'md5';
class App extends Component {
    constructor(props) {
        super(props)
        this.state = {
            categorylist: [],
            rewardlist: [],
            activePage: 1,
            formData: {}, // Contains login form data
            errors: {}, // Contains login field errors
            formSubmitted: false, // Indicates submit status of login form
            loading: false, // Indicates in progress state of login form
            pagecount: 1,
            playerid: null,
            tblprofile: [],
            user_id: null,
            point: null,
            products_page_count: 1,
            loginstate: false,
            firstname: null,
            lastname: null,
            alert: null,
        }
        this.handleClick = this.handleClick.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.hideAlert = this.hideAlert.bind(this);

    }
    handlePageChange(pageNumber) {
        //////console.log(`active page is ${pageNumber}`);
        this.setState({ activePage: pageNumber });

        instance
            .get("/api/v1/rewardlist", {
                params: {
                    Cat_ID: 0,
                    page: pageNumber
                }
            })
            .then((res) => {
                this.setState({
                    rewardlist: res.data.message.products,
                    pagecount: res.data.message.pagecount,
                    products_page_count: res.data.message.products_page_count
                });
            });
    }
    async opencliamcashout(evt, cityName) {
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        await instance.post("/api/v1/cliamcashout", {
          userid: Username,
          System: Systems,
        }, {
          headers: { Authorization: `Bearer ${token}` }
        }).then(async (res) => {
          if (res.data.status === 200) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            this.rechecklogin(Username, token);
            await Swal.fire({
              title: 'Success!',
              text: 'ทำรายการรับเงินเรียบร้อย',
              icon: 'success',
              confirmButtonText: 'ตกลง'
            })
    
          }
          else if (res.data.status === 201) {
            await Swal.fire({
              title: 'error!',
              text: 'ไม่สามารถทำรายการได้ ไม่มียอดเงิน',
              icon: 'error',
              confirmButtonText: 'ตกลง'
            })
            return false;
          }
          else if (res.data.status === 202) {
            await Swal.fire({
              title: 'error!',
              text: 'ไม่สามารถทำรายการได้',
              icon: 'error',
              confirmButtonText: 'ตกลง'
            })
            return false;
          }
    
        }).catch(async (err) => {
          // console.log(err);
          if (err.response.status === 401 || err.response.status === 403) {
            localStorage.clear();
            await Swal.fire({
              title: 'Warning!',
              text: 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง',
              icon: 'warning',
              confirmButtonText: 'ตกลง'
            })
            window.location.href = '/';
          }
        });
      }
    handleClick = async (e) => {
        this.setState({
            activePage: 1,
            isActive: true,
            activeTab: 0
        });
        instance.get("/api/v1/rewardlist", {
            params: {
                Cat_ID: e.target.id,
                page: 1
            }
        })
            .then((res) => {
                this.setState({
                    rewardlist: res.data.message.products,
                    pagecount: res.data.message.pagecount,
                    products_page_count: res.data.message.products_page_count
                });
            });
        this.setState({
            isActive: false
        });
    }

    hideAlert() {
        this.setState({
            alert: null
        });
    }


    checklogin() {
        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            this.setState({
                user_id: decoded.message.playerid,
                playerid: decoded.message.member_id,
                firstname: decoded.message.firstname,
                lastname: decoded.message.lastname,
                point: decoded.message.Point,
                loginstate: true,
            });
        }
        else {
            this.setState({
                loginstate: false,
            });
        }
    }
    rechecklogin = async (Username, token) => {
        try {

            //const { webnamex } = this.state
            //  console.log(1406, webnamex);
           // console.log(3);
            const search = window.location.href;
            const paramx = new URLSearchParams(search);
            // const space = search.split("/")
            const space = window.location.host
            var userhash = md5(Username);
            //  const linkaff = "https://pgline88.com/?register=" + userhash;
            const linkaff = "https://" + space + "/register?reg=" + userhash;
            await instance.post("/api/v1/checkpoint", {
                userid: Username,
                System: Systems,
                Update: userhash,
                Function: 'rechecklogin-App.js'
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                console.log(res.data);
                if (res.data.status === 200) {
                   // this.calllisthistory(Username);
                    //console.log(443, res.data);
                    localStorage.setItem('auth_token', res.data.token)
                    var rankall = res.data.tblrankall;
                    const found = rankall.find(obj => {
                        return obj.checked === 1;
                    });
                    console.log(138, res.data.message);
                    this.setState({
                        tblrankall: res.data.tblrankall,
                        linkaff: linkaff,
                        tblprofile: res.data.message,
                        buttoncliam: (found === undefined) ? true : false,
                        tblnextrank: res.data.tblnextrank,
                        rankpic: (res.data.tblrank.image == null || res.data.tblrank.image == "") ? "https://apixgen.javisx.com/build/rank/1.jpeg" : (res.data.tblrank.picrack == null || res.data.tblrank.picrack == "") ? "https://apixgen.javisx.com/build/rank/" + res.data.tblrank.image : res.data.tblrank.picrack,
                        rankname: res.data.tblrank.name,
                        rankob: res.data.tblrank,
                        rankpoint: res.data.rankpoint,
                        accnumber: res.data.message.accnumber,
                        userid: res.data.message.member_id,
                        username: res.data.message.playerid,
                        fullname: res.data.message.firstname,
                        point: res.data.message.Point,
                        balance: res.data.databalance,
                        loginstate: true,
                    });
                }
                else if (res.data.status === 401) {
                    localStorage.clear();
                    await Swal.fire({
                        title: 'Warning!',
                        text: 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง',
                        icon: 'warning',
                        confirmButtonText: 'ตกลง'
                    })
                    window.location.href = '/';
                }

            }).catch(async (err) => {
                 console.log(err);
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await Swal.fire({
                        title: 'Warning!',
                        text: 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง',
                        icon: 'warning',
                        confirmButtonText: 'ตกลง'
                    })
                    window.location.href = '/';
                }
            });
        }
        catch (ex) {
            ////////console.log(ex);
        }

    }

    async componentDidMount() {
        var token = localStorage.getItem('auth_token');
        const search = window.location.href;
        const params = new URLSearchParams(search);
        //////console.log(params);

        if (token != null) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            this.rechecklogin(Username, token);

        }
        await instance.post("/api/v1/mainsetting", {
            System: Systems,
        }).then((res) => {
            if (res.data.status === 200) {
                const datas = res.data.message;
                var min = res.data.tblcatagoryx[0].limitdeposit;
                var max = res.data.tblcatagoryx[0].maxdeposit;
                var maxwithdrawstatus = res.data.tblcatagoryx[0].withdrawmax
                var limit = { min, max }
                this.setState({
                    maxwithdrawstatus: maxwithdrawstatus,
                    linelink: datas[1].value,
                    webnamex: datas[7].value,
                    System: res.data.tblcatagoryx[0].System,
                    cashoutSet: res.data.tblcashoutsetting[0],
                    inviteSet: res.data.tblinvitedsetting[0],
                    typeinvite: res.data.tblinvitedsetting[0].caltype,
                    datas: datas,
                    limit: limit,
                });
            }
            else {
                // this.CheckThisGoalError();
            }
        });

    }

    render() {
        const { cashoutSet, typeinvite, inviteSet, loginstate, trueaccount, webnamex, stateopterror, changepassword, username, balance, accnumber, fullname, mainacc, limit, rankob, rankpoint, tblnextrank, userrecomend, linkaff, tblprofile, proderedeem, proderedeemlist, prodetail } = this.state

        return (
            <>
                <div className="x-main-content">
                    <div className="d-lg-none">
                        <div>
                            <br />
                            <br />
                            <br />
                        </div>
                        {/**/}
                        {/**/}
                        <div>{/**/}</div>
                        {/**/}
                        {/**/}
                    </div>
                    <section className="-contact-wrapper row m-0">
                        <div className="-games-provider-wrapper pl-0 pr-0 mx-auto -menu-index-page-bg col-12">
                            {/**/}
                        </div>
                        <div className="-games-index-page col-12">
                            <div className="mb-2 text-white-v1">
                                <div className="d-none d-lg-block">
                                    <div>
                                        <br />
                                        <br />
                                        <br />
                                    </div>
                                    {/**/}
                                    {/**/}
                                    <div>{/**/}</div>
                                    {/**/}
                                    {/**/}
                                </div>
                                {/**/}
                                <div className="padding-router-view">
                                    <div className="container p-0 x-margin-top-v3">
                                        <div className="row m-0 border-shadow-title">
                                            <div className="col-12 p-0 col-sm-7 col-md-7 col-lg-7 col-xl-7 mx-auto my-auto text-white-v1">
                                                <div className="text-center bg-title-web">
                                                    <div>
                                                        <div className="text-title text-white-v1 text-center">
                                                            <div className="d-flex justify-content-between">
                                                                <div className="text-white-v1-deposit">
                                                                    <a role="button" href='/'>
                                                                        <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width={25}
                                                                            height={25}
                                                                            fill="currentColor"
                                                                            className="bi bi-arrow-left-circle text-color-back"
                                                                            viewBox="0 0 16 16"
                                                                        >
                                                                            <path
                                                                                fillRule="evenodd"
                                                                                d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z"
                                                                            />
                                                                        </svg>
                                                                    </a>
                                                                </div>
                                                                <div className="text-white-v1-deposit">
                                                                    <h5>คืนยอดเสีย</h5>
                                                                </div>
                                                                <div>{/**/}</div>
                                                            </div>
                                                            <hr className="mt-0" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="p-2 bg-profile-box-overview">
                                                    {/**/}
                                                    <div className="mt-1 mb-1 w-100">
                                                        <div className="img">
                                                            <div
                                                                className="px-0 animated animatedFadeInUp fadeInUp card-width-banner"
                                                                style={{ marginBottom: 0, paddingTop: 10 }}
                                                            >
                                                                <div
                                                                    className="flicking-viewport"
                                                                    style={{
                                                                        userSelect: "none",
                                                                        WebkitUserDrag: "none",
                                                                        touchAction: "pan-y"
                                                                    }}
                                                                >
                                                                    <div
                                                                        className="flicking-camera"
                                                                        style={{ transform: "translate(-2.35617px)" }}
                                                                    >
                                                                        <div className="card-panel">
                                                                            <img
                                                                                className="px-1 img-banner"
                                                                                src="/build/web/igame-index-lobby-wm/img/ram-คืนยอดเสียทุกค่าย.jpg?v=1"
                                                                                alt="First slide"
                                                                                style={{ borderRadius: "0.5rem !important" }}
                                                                            />
                                                                        </div>
                                                                        <div className="card-panel">
                                                                            <img
                                                                                className="px-1 img-banner"
                                                                                src="/build/web/igame-index-lobby-wm/img/ram-คืนยอดเสียทุกค่าย.jpg?v=1"
                                                                                alt="First slide"
                                                                                style={{ borderRadius: "0.5rem !important" }}
                                                                            />
                                                                        </div>
                                                                        <div className="card-panel">
                                                                            <img
                                                                                className="px-1 img-banner"
                                                                                src="/build/web/igame-index-lobby-wm/img/ram-คืนยอดเสียทุกค่าย.jpg?v=1"
                                                                                alt="First slide"
                                                                                style={{ borderRadius: "0.5rem !important" }}
                                                                            />
                                                                        </div>
                                                                        <div className="card-panel">
                                                                            <img
                                                                                className="px-1 img-banner"
                                                                                src="/build/web/igame-index-lobby-wm/img/ram-คืนยอดเสียทุกค่าย.jpg?v=1"
                                                                                alt="First slide"
                                                                                style={{ borderRadius: "0.5rem !important" }}
                                                                            />
                                                                        </div>
                                                                        <div className="card-panel">
                                                                            <img
                                                                                className="px-1 img-banner"
                                                                                src="/build/web/igame-index-lobby-wm/img/ram-คืนยอดเสียทุกค่าย.jpg?v=1"
                                                                                alt="First slide"
                                                                                style={{ borderRadius: "0.5rem !important" }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        data-v-ab1d19ba=""
                                                        className="auction animated animatedFadeInUp fadeInUp"
                                                        role="button"
                                                    >
                                                        <div className="bg-profile-box-overview p-2 mt-2">
                                                            <div className="d-flex justify-content-between row m-0 align-items-center">
                                                                <div className="col-12 col-md-12 p-0">
                                                                    <div className="d-flex justify-content-between elementor-element-play-overview text-center bg-profile-credit-bl p-2">
                                                                        <div className="align-self-center">
                                                                            <div className="p-1 text-left">
                                                                                <div>
                                                                                    <h3 className="m-0">
                                                                                        <b className="p-1">{(tblprofile != null) ? tblprofile.Cashtotal : 0} </b>
                                                                                    </h3>
                                                                                </div>
                                                                                <small>คืนยอดเสียสะสมทั้งหมด</small>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="bg-profile-box-overview p-2 mt-2">
                                                            <div className="d-flex justify-content-between row m-0 align-items-center">
                                                                <div className="col-12 col-md-12 p-0">
                                                                    <div className="d-flex justify-content-between elementor-element-play-overview text-center bg-profile-credit-bl p-2">
                                                                        <div className="align-self-center">
                                                                            <div className="p-1 text-left">
                                                                                <div>
                                                                                    <h3 className="m-0">
                                                                                        <b className="p-1">{(tblprofile != null) ? tblprofile.Cashtotal : 0}</b>
                                                                                    </h3>
                                                                                </div>
                                                                                <small>คืนยอดเสียสะสมเดือนนี้</small>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="bg-profile-box-overview p-2 mt-2">
                                                            <div className="bg-color-financial-my-bank bg-profile-box-overview">
                                                                <div className="d-flex justify-content-between pt-3 pb-3">
                                                                    <div>
                                                                        <small>คืนยอดเสีย {(cashoutSet != null) ? cashoutSet.percent : 0}%</small>
                                                                    </div>
                                                                    <div>
                                                                        <small>ยอดเริ่มต้น 10 บาท</small>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="d-flex justify-content-between financial-button mt-2 animated animatedFadeInUp fadeInUp">
                                                            <div
                                                                role="button"
                                                                className="align-self-center p-1 credit-bl-text"
                                                            >
                                                                <div role="button" className="financial-button-r">
                                                                    <div className="d-flex justify-content-start">
                                                                        <div className="align-self-center">
                                                                            <img
                                                                                className="logo-profile-user-w p-1"
                                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/48a22d9a-8abe-477f-0f40-57204ce17700/public"
                                                                                alt=""
                                                                            />
                                                                        </div>
                                                                        <div className="align-self-center">
                                                                            <div className="username-profile">
                                                                                <small>ยอดเสียของคุณ</small>
                                                                            </div>
                                                                            <div className="username-profile">
                                                                                <small>
                                                                                    <b className="font-aff-wid">{(tblprofile != null) ? tblprofile.Cashtotal : 0}</b>
                                                                                </small>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="align-self-center">
                                                                <a role="button"
                                                                    onClick={(e) => {
                                                                        this.opencliamcashout(e, 'bonusrankaccount')
                                                                    }}>
                                                                    <div className="bg-text-highlight pd-bl-aff">
                                                                        <div
                                                                            disabled="false"
                                                                            role="button"
                                                                            className="btn -submit js-submit-accept-term mt-0 w-100 p-2"
                                                                        >
                                                                            <img
                                                                                className="wid-button p-1"
                                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/de26db72-10a7-4369-5e7e-dd07d4568300/public"
                                                                                alt=""
                                                                            />
                                                                            <span>ถอนเงิน</span>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </div>
                                                        {/**/}
                                                    </div>
                                                    <div className="p-2 text-left mt-4 mb-1 animated animatedFadeInUp fadeInUp credit-bl-text">
                                                        ประวัติการทำรายการ
                                                    </div>
                                                    <div className="animated animatedFadeInUp fadeInUp">
                                                        <div>
                                                            <div className="text-white-v1 text-center">
                                                                <div>
                                                                    <div className="bg-profile-box-overview p-2 text-center animated animatedFadeInUp fadeInUp">
                                                                        <b>
                                                                            <img
                                                                                className="load-history"
                                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/e4ac87bf-3687-4f37-c96e-6ad9e797bf00/public"
                                                                                alt=""
                                                                            />
                                                                            <div className="not-history font-history-menu-text p-2">
                                                                                <small>
                                                                                    <b>ไม่พบรายการ...</b>
                                                                                </small>
                                                                            </div>
                                                                        </b>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <div>
                        <div className="box-class">
                            <div>
                                <div className="bg-view pt-3 pb-3">
                                    <div className="container">
                                        <div className="page-view-index text-center">
                                            {/**/}
                                            <div className="logo-web">
                                                <img
                                                    src="/build/web/igame-index-lobby-wm/img/logo.png?v=1"
                                                    className="logo-web-page"
                                                    alt=""
                                                />
                                            </div>
                                            <div className="details-page-view text-left">
                                                <div className="js-replace-heading-sub-title-seo-container animated animatedFadeInUp fadeInUp mt-2 text-left">
                                                    <h2 className="-heading-sub-title m-0 p-2-view-page">
                                                        <b>
                                                            Secret789 เว็บที่ให้บริการคาสิโนออนไลน์เต็มรูปแบบ
                                                            ทั้งสล็อตออนไลน์ คาสิโนสด บาคาร่าสด เกมแทงปลา เกมกีฬา ฯลฯ
                                                        </b>
                                                    </h2>
                                                    <p className="text-details-box">
                                                        โดยผู้เล่นสามารถสนุกกับเกมของเราได้ด้วยเงินเดิมพันขั้นต่ำเพียง
                                                        10 บาทเท่านั้น และสามารถทำการฝาก-ถอนได้ตลอด 24 ชั่วโมง
                                                        ด้วยระบบออโต้ ทั้งสะดวก
                                                        รวดเร็วทันใจเป็นอย่างมากเหมาะสำหรับผู้ที่ชื่นชอบการเดิมพันในรูปแบบของเกมการพนันออนไลน์อันดับ
                                                        1 ในปี 2021
                                                    </p>
                                                    <h2 className="-heading-sub-title m-0 p-2-view-page">
                                                        <b>
                                                            Secret789 บริการประทับใจ ก็ไม่เป็นสองรองใคร ใส่ใจทุกคำตอบ
                                                            ตลอด 24 ชั่วโมง 7 วันต่อสัปดาห์ไม่มีหยุด
                                                        </b>
                                                    </h2>
                                                    <p className="text-details-box">
                                                        เพราะผู้เล่นทุกท่าน คือ คนสำคัญของเรา
                                                        และเรายังมีทีมลูกค้าสัมพันธ์ที่คอยให้ความช่วยเหลือ
                                                        ตอบทุกคำถาม ให้บริการทุกเรื่องที่คุณสงสัยตลอด 24 ชั่วโมง
                                                        เพื่อให้คนสำคัญของเราไม่ต้องกังวลกับปัญหาที่พบตั้งแต่ต้นจนจบ
                                                        นอกจากนี้ เรายังมีเว็บคาสิโน
                                                        และสล็อตพันธมิตรชั้นนำที่พร้อมมาเสิร์ฟความหลากหลายของเกม
                                                        และความสนุกสนาน ให้คุณได้เพลิดเพลิน เช่น SA Gaming, Secret789
                                                        Gaming, WM Casino, Dream Gaming, Pretty Gaming, ALLBET,
                                                        Joker, PG Slot และอื่นๆ อีกมากมายจนผู้เล่นจะติดใจอย่างแน่นอน
                                                    </p>
                                                </div>
                                            </div>
                                            {/**/}
                                            {/**/}
                                            <div
                                                className="row"
                                                data-id="12d4edb6"
                                                data-element_type="container"
                                                data-settings='{"content_width":"boxed"}'
                                            >
                                                <div
                                                    className="elementor-element elementor-element-2982ecdc e-con-full e-flex e-con col-12 col-md-4"
                                                    data-id="2982ecdc"
                                                    data-element_type="container"
                                                    data-settings='{"content_width":"full"}'
                                                >
                                                    <div
                                                        className="elementor-element elementor-element-46eac4a6 elementor-widget frame-2-black elementor-widget-image mb-3"
                                                        data-id="46eac4a6"
                                                        data-element_type="widget"
                                                        data-widget_type="image.default"
                                                    >
                                                        <div className="elementor-widget-container">
                                                            {/**/}
                                                            <img
                                                                decoding="async"
                                                                width={400}
                                                                height={300}
                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/4c274881-0b91-494d-e091-319538b91700/public"
                                                                className="attachment-large size-large wp-image-64 entered lazyloaded"
                                                                alt=""
                                                                data-lazy-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/4c274881-0b91-494d-e091-319538b91700/public"
                                                                data-lazy-sizes="(max-width: 400px) 100vw, 400px"
                                                                data-lazy-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/4c274881-0b91-494d-e091-319538b91700/public"
                                                                data-ll-status="loaded"
                                                                sizes="(max-width: 400px) 100vw, 400px"
                                                                srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/4c274881-0b91-494d-e091-319538b91700/public"
                                                            />
                                                            <noscript>
                                                                &lt;img decoding="async" :src="hot_img_1"
                                                                class="attachment-large size-large wp-image-64" alt=""
                                                                :srcset="hot_img_1" /&gt;
                                                            </noscript>
                                                        </div>
                                                        <div className="elementor-widget-container p-3 text-left">
                                                            <p className="text-details-box">
                                                                ผู้ริเริ่มและผู้ให้บริการเกมคาสิโนชั้นนำรวบรวมเอาไว้อย่างครบครัน
                                                                ตอบโจทย์ได้ดีที่สุด มีเกมให้เลือกหลากหลาย เล่นง่าย
                                                                ไม่รู้สึกเบื่อ ระบบที่มีความเสถียรภาพ
                                                                พัฒนาให้มีความทันสมัยอยู่ตลอดเวลา
                                                                สัมผัสบรรยากาศที่สมจริงถ่ายทอดสดให้ได้ร่วมติดตามผลการเดิมพันอย่างใกล้ชิด
                                                                ลุ้นสนุกตลอด 24 ชั่วโมง evocasino เปิดประสบการณ์ใหม่ๆ
                                                                สร้างความตื่นตาตื่นใจได้เป็นอย่างดี
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    className="elementor-element elementor-element-2982ecdc e-con-full e-flex e-con col-12 col-md-4"
                                                    data-id="2982ecdc"
                                                    data-element_type="container"
                                                    data-settings='{"content_width":"full"}'
                                                >
                                                    <div
                                                        className="elementor-element elementor-element-46eac4a6 elementor-widget frame-2-black elementor-widget-image mb-3"
                                                        data-id="46eac4a6"
                                                        data-element_type="widget"
                                                        data-widget_type="image.default"
                                                    >
                                                        <div className="elementor-widget-container">
                                                            {/**/}
                                                            <img
                                                                decoding="async"
                                                                width={400}
                                                                height={300}
                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/ef6d4562-8d14-4943-5d30-88547959dd00/public"
                                                                className="attachment-large size-large wp-image-64 entered lazyloaded"
                                                                alt=""
                                                                data-lazy-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/ef6d4562-8d14-4943-5d30-88547959dd00/public"
                                                                data-lazy-sizes="(max-width: 400px) 100vw, 400px"
                                                                data-lazy-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/ef6d4562-8d14-4943-5d30-88547959dd00/public"
                                                                data-ll-status="loaded"
                                                                sizes="(max-width: 400px) 100vw, 400px"
                                                                srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/ef6d4562-8d14-4943-5d30-88547959dd00/public"
                                                            />
                                                            <noscript>
                                                                &lt;img decoding="async" :src="hot_img_2"
                                                                class="attachment-large size-large wp-image-64" alt=""
                                                                :srcset="hot_img_2" /&gt;
                                                            </noscript>
                                                        </div>
                                                        <div className="elementor-widget-container p-3 text-left">
                                                            <p className="text-details-box">
                                                                ผู้ริเริ่มและผู้ให้บริการเกมคาสิโนชั้นนำรวบรวมเอาไว้อย่างครบครัน
                                                                ตอบโจทย์ได้ดีที่สุด มีเกมให้เลือกหลากหลาย เล่นง่าย
                                                                ไม่รู้สึกเบื่อ ระบบที่มีความเสถียรภาพ
                                                                พัฒนาให้มีความทันสมัยอยู่ตลอดเวลา
                                                                สัมผัสบรรยากาศที่สมจริงถ่ายทอดสดให้ได้ร่วมติดตามผลการเดิมพันอย่างใกล้ชิด
                                                                ลุ้นสนุกตลอด 24 ชั่วโมง evocasino เปิดประสบการณ์ใหม่ๆ
                                                                สร้างความตื่นตาตื่นใจได้เป็นอย่างดี
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    className="elementor-element elementor-element-2982ecdc e-con-full e-flex e-con col-12 col-md-4"
                                                    data-id="2982ecdc"
                                                    data-element_type="container"
                                                    data-settings='{"content_width":"full"}'
                                                >
                                                    <div
                                                        className="elementor-element elementor-element-46eac4a6 elementor-widget frame-2-black elementor-widget-image mb-3"
                                                        data-id="46eac4a6"
                                                        data-element_type="widget"
                                                        data-widget_type="image.default"
                                                    >
                                                        <div className="elementor-widget-container">
                                                            {/**/}
                                                            <img
                                                                decoding="async"
                                                                width={400}
                                                                height={300}
                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/56266019-b3c7-4052-597c-21d641460700/public"
                                                                className="attachment-large size-large wp-image-64 entered lazyloaded"
                                                                alt=""
                                                                data-lazy-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/56266019-b3c7-4052-597c-21d641460700/public"
                                                                data-lazy-sizes="(max-width: 400px) 100vw, 400px"
                                                                data-lazy-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/56266019-b3c7-4052-597c-21d641460700/public"
                                                                data-ll-status="loaded"
                                                                sizes="(max-width: 400px) 100vw, 400px"
                                                                srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/56266019-b3c7-4052-597c-21d641460700/public"
                                                            />
                                                            <noscript>
                                                                &lt;img decoding="async" :src="hot_img_3"
                                                                class="attachment-large size-large wp-image-64" alt=""
                                                                :srcset="hot_img_3" /&gt;
                                                            </noscript>
                                                        </div>
                                                        <div className="elementor-widget-container p-3 text-left">
                                                            <p className="text-details-box">
                                                                ผู้ริเริ่มและผู้ให้บริการเกมคาสิโนชั้นนำรวบรวมเอาไว้อย่างครบครัน
                                                                ตอบโจทย์ได้ดีที่สุด มีเกมให้เลือกหลากหลาย เล่นง่าย
                                                                ไม่รู้สึกเบื่อ ระบบที่มีความเสถียรภาพ
                                                                พัฒนาให้มีความทันสมัยอยู่ตลอดเวลา
                                                                สัมผัสบรรยากาศที่สมจริงถ่ายทอดสดให้ได้ร่วมติดตามผลการเดิมพันอย่างใกล้ชิด
                                                                ลุ้นสนุกตลอด 24 ชั่วโมง evocasino เปิดประสบการณ์ใหม่ๆ
                                                                สร้างความตื่นตาตื่นใจได้เป็นอย่างดี
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/**/}
                                        {/**/}
                                        {/**/}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="box-class">
                        <div>
                            <div className="bg-view-box-section pt-1 pb-1">
                                <div className="container p-0">
                                    <section className="carousel" dir="ltr" aria-label="Gallery">
                                        <div className="carousel__viewport">
                                            <ol
                                                className="carousel__track"
                                                style={{
                                                    transform: "translateX(82.5px)",
                                                    transition: "all 0ms ease 0s"
                                                }}
                                            >
                                                <li
                                                    className="carousel__slide carousel__slide--next"
                                                    style={{ width: "12.5%", order: 7 }}
                                                >
                                                    <img
                                                        className="w-100 px-2"
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/07bcba7a-7a0c-4d1e-15cb-26fb38a3e600/public"
                                                        alt="First slide"
                                                        style={{ borderRadius: "0.5rem !important" }}
                                                    />
                                                </li>
                                                <li
                                                    className="carousel__slide"
                                                    style={{ width: "12.5%", order: 8 }}
                                                >
                                                    <img
                                                        className="w-100 px-2"
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/64537eec-be94-4be2-47a6-756dc1c5c000/public"
                                                        alt="First slide"
                                                        style={{ borderRadius: "0.5rem !important" }}
                                                    />
                                                </li>
                                                <li
                                                    className="carousel__slide"
                                                    style={{ width: "12.5%", order: 9 }}
                                                >
                                                    <img
                                                        className="w-100 px-2"
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/6a7ead18-07b8-4e71-842b-dfcc221a5d00/public"
                                                        alt="First slide"
                                                        style={{ borderRadius: "0.5rem !important" }}
                                                    />
                                                </li>
                                                <li
                                                    className="carousel__slide"
                                                    style={{ width: "12.5%", order: 10 }}
                                                >
                                                    <img
                                                        className="w-100 px-2"
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/20572201-044e-490c-e230-32e3374c8a00/public"
                                                        alt="First slide"
                                                        style={{ borderRadius: "0.5rem !important" }}
                                                    />
                                                </li>
                                                <li
                                                    className="carousel__slide"
                                                    style={{ width: "12.5%", order: 11 }}
                                                >
                                                    <img
                                                        className="w-100 px-2"
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/044ed0b6-fb92-43ce-eb8e-4f5e46f7ca00/public"
                                                        alt="First slide"
                                                        style={{ borderRadius: "0.5rem !important" }}
                                                    />
                                                </li>
                                                <li
                                                    className="carousel__slide carousel__slide--visible"
                                                    style={{ width: "12.5%", order: 0 }}
                                                >
                                                    <img
                                                        className="w-100 px-2"
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/54c179cd-b256-403b-7cdc-9734704b3900/public"
                                                        alt="First slide"
                                                        style={{ borderRadius: "0.5rem !important" }}
                                                    />
                                                </li>
                                                <li
                                                    className="carousel__slide carousel__slide--visible"
                                                    style={{ width: "12.5%", order: 1 }}
                                                >
                                                    <img
                                                        className="w-100 px-2"
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/b73f287f-d002-4630-4bfd-aa4cceb27000/public"
                                                        alt="First slide"
                                                        style={{ borderRadius: "0.5rem !important" }}
                                                    />
                                                </li>
                                                <li
                                                    className="carousel__slide carousel__slide--visible"
                                                    style={{ width: "12.5%", order: 2 }}
                                                >
                                                    <img
                                                        className="w-100 px-2"
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/af06505d-1d58-4d3b-530f-114355fa0e00/public"
                                                        alt="First slide"
                                                        style={{ borderRadius: "0.5rem !important" }}
                                                    />
                                                </li>
                                                <li
                                                    className="carousel__slide carousel__slide--active carousel__slide--visible"
                                                    style={{ width: "12.5%", order: 3 }}
                                                >
                                                    <img
                                                        className="w-100 px-2"
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/2019b9ac-6a16-4469-2843-5216145cbe00/public"
                                                        alt="First slide"
                                                        style={{ borderRadius: "0.5rem !important" }}
                                                    />
                                                </li>
                                                <li
                                                    className="carousel__slide carousel__slide--visible"
                                                    style={{ width: "12.5%", order: 4 }}
                                                >
                                                    <img
                                                        className="w-100 px-2"
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/2e851070-5ef3-4dd9-1da3-d78dd483dd00/public"
                                                        alt="First slide"
                                                        style={{ borderRadius: "0.5rem !important" }}
                                                    />
                                                </li>
                                                <li
                                                    className="carousel__slide carousel__slide--visible"
                                                    style={{ width: "12.5%", order: 5 }}
                                                >
                                                    <img
                                                        className="w-100 px-2"
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/826d3993-4a9d-4b34-0db0-d8418d10b000/public"
                                                        alt="First slide"
                                                        style={{ borderRadius: "0.5rem !important" }}
                                                    />
                                                </li>
                                                <li
                                                    className="carousel__slide carousel__slide--visible"
                                                    style={{ width: "12.5%", order: 6 }}
                                                >
                                                    <img
                                                        className="w-100 px-2"
                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/e5ca4a47-0528-45c3-7f13-e181ee13a300/public"
                                                        alt="First slide"
                                                        style={{ borderRadius: "0.5rem !important" }}
                                                    />
                                                </li>
                                            </ol>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className="bg-view-footer pt-3 pb-5-mobile">
                                <div className="container p-0 text-center text-details-box">
                                    <h2 className="-heading-sub-title m-0 p-2-view-page">
                                        <b>Secret789 เว็บคาสิโนออนไลน์</b> <br />
                                    </h2>
                                    <small>
                                        Secret789 บาคาร่า คาสิโนออนไลน์ ที่ดีที่สุด
                                        เพื่อประสบการณ์ที่ดีของผู้เล่นอย่างแท้จริง แบบ Secret789
                                    </small>
                                    <div>
                                        <small>
                                            <b>Created website by</b>
                                        </small>
                                    </div>
                                    <img
                                        src="/build/web/igame-index-lobby-wm/img/logo.png?v=1"
                                        className="logo-web-page"
                                        alt=""
                                    />
                                    <div>
                                        <small>
                                            <b>Terms and Conditions</b>
                                        </small>
                                    </div>
                                    <div className="pt-2 pb-2">
                                        <small>
                                            <b>Copyright © 2021 Secret789 All Rights Reserved.</b>
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </>

        );
    }
}
export default App;
